// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Plaintext/Plaintext.less
// module id = 225
// module chunks = 2